import { EventEmitter } from '@angular/core';
import { IdentifiableData } from '@shared/models/generictablecolumn';
import { Observable } from 'rxjs';

export class SelectManager<T extends IdentifiableData> {
	private selectedItems: { [key: string]: T } = {};
	private data: T[];

	public selectedKeyList = new EventEmitter<string[]>();
	public selectedList = new EventEmitter<T[]>();
	public selectedEvent = new EventEmitter<T>();
	public unSelectedEvent = new EventEmitter<T>();
	public dataChanged = new EventEmitter<T[]>();
	public isAllSelected: boolean;

	constructor() {}

	setData(data: T[] | Observable<T[]>, resetSelection: boolean = true) {
		if (Array.isArray(data)) {
			this.data = data;
			this.dataChanged.emit(data);
			if (resetSelection) {
				this.resetSelection();
			} else {
				this.evaluateIsAllSelected();
			}
		} else if (data instanceof Observable) {
			data.subscribe((data: T[]) => {
				this.setData(data, resetSelection);
			});
		} else {
			throw new TypeError('Invalid data source provided to SelectManager');
		}
	}

	private evaluateIsAllSelected() {
		if (this.data && this.data.length > 0) {
			this.isAllSelected = this.data.every((item) => Object.prototype.hasOwnProperty.call(this.selectedItems, item.id));
		} else {
			this.isAllSelected = false;
		}
	}

	public select(row: T) {
		const index = this.selectedItems[row.id];
		if (index === undefined) {
			this.selectedItems[row.id] = row;
			this.selectedEvent.emit(row);
		} else {
			delete this.selectedItems[row.id];
			this.unSelectedEvent.emit(row);
		}
		this.isAllSelected = this.data.length === Object.keys(this.selectedItems).length;

		this.emitSelected();
	}

	public selectOrClearAll() {
		if (this.data.length === this.selectCount()) {
			console.log('Clearing all selections');
			// save selected items before clearing
			const tmp = Object.values(this.selectedItems);
			// reset selection and emit empty selected list
			this.resetSelection();
			// emit unselected events for previously selected items
			for (const row of tmp) {
				this.unSelectedEvent.emit(row);
			}
		} else {
			console.log('Selecting all items');
			this.data.forEach((element) => {
				if (!this.isSelected(element.id)) {
					this.selectedEvent.emit(element);
					this.selectedItems[element.id] = element; // Add to selected items
				}
			});
			this.isAllSelected = true; // Set all selected to true
		}
		this.emitSelected();
	}

	private emitSelected() {
		this.selectedList.emit(Object.values(this.selectedItems));
		this.selectedKeyList.emit(Object.keys(this.selectedItems));
	}

	public selectCount() {
		return Object.keys(this.selectedItems).length;
	}

	public isSelected(id: string): boolean {
		return Object.prototype.hasOwnProperty.call(this.selectedItems, id);
	}

	public isAnySelected(): boolean {
		return Object.keys(this.selectedItems).length > 0;
	}

	public getSelectedItems(): T[] {
		return Object.values(this.selectedItems);
	}

	public resetSelection() {
		this.selectedItems = {};
		this.isAllSelected = false;
		this.emitSelected();
	}
}
